module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In early 1915 the BEF was still in the process of recovery from the fighting that had taken place the previous year and, although reinforced to some extent by Territorial Force battalions, the first volunteer divisions of Kitchener’s New Army were only just beginning to arrive in France and these were certainly not comparable in terms of training and experience to the professionals and reservists of the army which fought the battles of 1914. It would be the middle of 1916 when the British Army was finally capable of mounting and sustaining a very large-scale offensive in its own right.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644c06e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/23_fm036.vue
// module id = 126
// module chunks = 0